
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/microbusinesses",
      function () {
        return require("private-next-pages/microbusinesses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/microbusinesses"])
      });
    }
  